export const PROFILE_CONTRIBUTION_REGISTRY = [
  { key: "places", label: "Lugares agregados", icon: "📍", active: true },
  // `reviews.comentario` is the canonical text contribution. Keep one stream instead
  // of duplicating the same row into artificial "review" and "comment" records.
  { key: "reviews", label: "Reseñas / comentarios", icon: "💬", active: true },
  { key: "replies", label: "Respuestas", icon: "↩️", active: false },
  { key: "votes", label: "Votaciones", icon: "🗳️", active: false },
  { key: "coupons", label: "Cupones", icon: "🎟️", active: false },
];

const sameId = (a, b) => String(a ?? "") === String(b ?? "");

export const visibleProfileContributionTypes = () =>
  PROFILE_CONTRIBUTION_REGISTRY.filter(type => type.active);

export const contributionStatus = item => {
  if (item?.metadata?.rejected) return { key: "rejected", label: "Rechazado", color: "#e57373" };
  if (item?.pending) return { key: "pending", label: "En revisión", color: "#f59e0b" };
  return { key: "published", label: "Publicado", color: "#5cb85c" };
};

export const buildProfileContributions = ({ places = [], reviews = [], userId }) => {
  const ownPlaces = places
    .filter(place => sameId(place?.addedBy, userId))
    .map(place => ({
      kind: "place",
      id: place.id,
      item: place,
      place,
      status: contributionStatus(place),
    }));

  const ownReviews = reviews
    .filter(review => sameId(review?.userid, userId))
    .map(review => {
      const placeId = review.placeid ?? review.placeId;
      const place = places.find(candidate => sameId(candidate?.id, placeId)) || null;
      return {
        kind: "review",
        id: review.id,
        item: review,
        review,
        place,
        placeId,
        status: contributionStatus(review),
      };
    });

  return { places: ownPlaces, reviews: ownReviews };
};

export const resolveProfileContributionTab = (requested, contributions) => {
  const activeKeys = visibleProfileContributionTypes().map(type => type.key);
  if (activeKeys.includes(requested)) return requested;
  if (contributions?.places?.length) return "places";
  if (contributions?.reviews?.length) return "reviews";
  return "places";
};

export const buildProfileDetailReviews = ({
  allReviews = [],
  visibleReviews = [],
  placeId,
  highlightReviewId = null,
  userId,
}) => {
  const visibleForPlace = visibleReviews.filter(review => sameId(review?.placeid ?? review?.placeId, placeId));
  if (highlightReviewId === null || highlightReviewId === undefined) return visibleForPlace;

  const target = allReviews.find(review =>
    sameId(review?.id, highlightReviewId)
    && sameId(review?.userid, userId)
    && sameId(review?.placeid ?? review?.placeId, placeId)
  );
  if (!target || visibleForPlace.some(review => sameId(review?.id, target.id))) return visibleForPlace;
  return [...visibleForPlace, target];
};